import React from 'react';

import { useEntityCustomFieldsByRecordType } from 'views/fieldConfigs/hooks/useCustomFieldsByRecordType';
import { entitiesName } from 'views/CRM/shared/utils/entitiesName';
import OpportunityService from '../../../services/opportunityService';
import { POSSIBLE_FILTERS_ENTITIES } from '../../../../../../hooks/useMemorizeInputsFilters';
import ImportDataForm from 'components/ImportData';
import { defaultImportFields } from 'components/ImportData/data/fields';

/**
 * Componente ImportAccountsModal para gerenciar a importação de dados de contas.
 *
 * @component
 * @param {Object} props - Propriedades do componente
 * @param {boolean} props.isOpen - Controla se o modal está visível
 * @param {Function} props.setIsOpen - Função para alternar a visibilidade do modal
 * @param {string|number} props.recordTypeId - ID do tipo de registro para o qual as contas estão sendo importadas
 *
 * @returns {JSX.Element} A interface do modal de importação de contas
 */

const ImportOpportunitiesModal = ({ isOpen, setIsOpen, recordTypeId }) => {
  const { getCustomFields } = useEntityCustomFieldsByRecordType(
    entitiesName.OPPORTUNITY,
    recordTypeId
  );

  return (
    <ImportDataForm
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      recordTypeId={recordTypeId}
      importService={OpportunityService.importOpportunities}
      defaultFields={defaultImportFields.CRM_OPPORTUNITY}
      filterEntity={POSSIBLE_FILTERS_ENTITIES.CRM_OPPORTUNITY_IMPORT}
      getCustomFields={getCustomFields}
    />
  );
};

export default ImportOpportunitiesModal;
